module.exports = __webpack_public_path__ + "img/2.a62162e0.jpg";